import React, { useState } from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBBtn, toast } from "mdbreact";
import axios from "../../../../axios";

function QuickSearchToolbar() {
    return (
        <Box
            sx={{
                p: 0.5,
                pb: 0,
            }}
        >
            <GridToolbarQuickFilter />
        </Box>
    );
}

export default function Basic(props) {
    const [modalConfirmDisconnect, setModalConfirmDisconnect] = useState(false);
    const [selectedVenue, setSelectedVenue] = useState(null);
    const [isDisconnecting, setIsDisconnecting] = useState(false);

    const toggleConfirmDisconnect = (venue = null) => {
        setModalConfirmDisconnect(!modalConfirmDisconnect);
        setSelectedVenue(venue);
    };

    const confirmDisconnectVenue = () => {
        if (!selectedVenue) return;

        setIsDisconnecting(true);
        let body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            IdToken: sessionStorage.getItem("IdToken"),
            KeyPoolID: props.keyPoolID,
            disconnectVenueID: selectedVenue.id,
        };
        axios
            .post("/networkoperatorconsole/keypools/configureKeypool", body, {
                headers: { "api-version": "20260417" },
            })
            .then(
                (response) => {
                    toast.success("Venue disconnected successfully!", {
                        closeButton: false,
                    });
                    toggleConfirmDisconnect();
                    setIsDisconnecting(false);
                    if (props.onVenueDisconnected) {
                        props.onVenueDisconnected();
                    }
                },
                (error) => {
                    toast.error(
                        error.response?.data?.message ||
                            "There was an error disconnecting the venue!",
                        {
                            closeButton: false,
                        }
                    );
                    setIsDisconnecting(false);
                }
            );
    };

    let userAttributes = [];
    let i = 0;
    let columns = [];
    let rows = [];
    if (props.venueList !== undefined) {
        for (const key of Object.keys(props.venueList)) {
            let Address2 =
                props.venueList[key]["AddressLine2"] !== ""
                    ? props.venueList[key]["AddressLine2"] + "\n"
                    : "";
            userAttributes.push({
                id: key,
                venueName: props.venueList[key]["VenueName"],
                venueAddress:
                    props.venueList[key]["AddressLine1"] +
                    "\n" +
                    Address2 +
                    props.venueList[key]["City"] +
                    ", " +
                    props.venueList[key]["State"] +
                    " " +
                    props.venueList[key]["PostalCode"],
            });
            i = i + 1;
        }
    }

    columns = [
        {
            headerName: "Venue",
            field: "venueName",
            minWidth: 150,
            flex: 0.4,
        },
        {
            headerName: "Address",
            field: "venueAddress",
            minWidth: 200,
            flex: 0.4,
        },
        {
            headerName: "Action",
            field: "action",
            minWidth: 150,
            flex: 0.2,
            renderCell: (params) => (
                <Button
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        toggleConfirmDisconnect(params.row);
                    }}
                    sx={{
                        textTransform: "none",
                        fontSize: "0.875rem",
                        "&:hover": {
                            backgroundColor: "var(--primary-color, #007bff)",
                            color: "#000000",
                        },
                    }}
                >
                    Disconnect
                </Button>
            ),
        },
    ];
    rows = userAttributes;
    return (
        <>
            <MDBModal
                isOpen={modalConfirmDisconnect}
                toggle={() => toggleConfirmDisconnect()}
            >
                <MDBModalHeader toggle={() => toggleConfirmDisconnect()}>
                    Confirm Disconnect Venue
                </MDBModalHeader>
                <MDBModalBody>
                    <p>
                        Are you sure you want to disconnect{" "}
                        <strong>{selectedVenue?.venueName}</strong> from this
                        keypool?
                    </p>
                </MDBModalBody>
                <MDBModalFooter>
                    <MDBBtn
                        color="danger"
                        onClick={confirmDisconnectVenue}
                        disabled={isDisconnecting}
                    >
                        {isDisconnecting ? (
                            <div
                                className="spinner-border spinner-border-sm"
                                role="status"
                            >
                                <span className="sr-only">Loading...</span>
                            </div>
                        ) : (
                            "Disconnect"
                        )}
                    </MDBBtn>
                    <MDBBtn
                        color="secondary"
                        onClick={() => toggleConfirmDisconnect()}
                    >
                        Cancel
                    </MDBBtn>
                </MDBModalFooter>
            </MDBModal>
            <div style={{ height: 300, width: "100%" }}>
            <DataGrid
                rows={rows}
                columns={columns}
                hideFooterPagination={false}
                hideFooter={false}
                getRowHeight={({ id, densityFactor }) => {
                    return 50 * densityFactor;
                }}
                slots={{ toolbar: QuickSearchToolbar }}
            />
        </div>
        </>
    );
}
